import React from 'react';

const Registrations = ({ data, settings = {} }) => {
  if (!data || data.length === 0) {
    return <div className="pco-empty"><p>No registration events available at this time.</p></div>;
  }

  const layout = settings['pco-layout'] || 'cards';

  if (layout === 'featured') {
    const featured = data[0];
    const rest = data.slice(1);
    return (
      <div className="pco-reg-featured">
        <div className="pco-reg-hero">
          {featured.image_url ? (
            <img className="pco-card-image" src={featured.image_url} alt={featured.name} loading="lazy" />
          ) : (
            <div className="pco-card-image" />
          )}
          <div className="pco-card-body">
            <h3>{featured.name}</h3>
            {featured.description && <p>{featured.description}</p>}
            <a className="button" href={featured.url || '#'} target="_blank" rel="noopener">Register Now</a>
          </div>
        </div>
        {rest.length > 0 && (
          <div className="pco-reg-remaining">
            {rest.map(reg => (
              <div className="pco-card" key={reg.id}>
                {reg.image_url ? (
                  <img className="pco-card-image" src={reg.image_url} alt={reg.name} loading="lazy" />
                ) : (
                  <div className="pco-card-image" />
                )}
                <div className="pco-card-body">
                  <h3>{reg.name}</h3>
                  {reg.description && <p>{reg.description}</p>}
                  <a className="button" href={reg.url || '#'} target="_blank" rel="noopener">Register Now</a>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    );
  }

  // Cards (default)
  return (
    <div className="pco-reg-grid">
      {data.map(reg => (
        <div className="pco-card" key={reg.id}>
          {reg.image_url ? (
            <img className="pco-card-image" src={reg.image_url} alt={reg.name} loading="lazy" />
          ) : (
            <div className="pco-card-image" />
          )}
          <div className="pco-card-body">
            <h3>{reg.name}</h3>
            {reg.description && <p>{reg.description}</p>}
            <a className="button" href={reg.url || '#'} target="_blank" rel="noopener">Register</a>
          </div>
        </div>
      ))}
    </div>
  );
};

export default Registrations;
